import { AppBar, Button, Toolbar, Typography } from '@material-ui/core';
// import Button from '@material-ui/core/Button';
import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';
import RestaurantMenu from '@material-ui/icons/RestaurantMenu';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link, NavLink } from 'react-router-dom';
// scroll to top button
// import { CircleArrow as ScrollUpButton } from "react-scroll-up-button";
import ScrollUpButton from 'react-scroll-up-button';
import Scrollspy from 'react-scrollspy';
// import AddItem from './AddItem';
import Categories from './Categories';
import Footer from './components/Footer';
import strings from './components/language/language';
import Scroll from './components/Scroll';
import Order from './Order';
import ScrollButton from './ScrollButton';
import ScrollNav from './Scrollspy';
import SearchBar from './SearchBar';
import ReactPixel from 'react-facebook-pixel';

const StyledBadge = withStyles((theme) => ({
  badge: {
    position: 'absolute',
    right: -7,
    top: -10,
    backgroundColor: '#70142c',
    color: '#fff',
  },
}))(Badge);

const styles = (theme) => ({
  header: {
    backgroundColor: '#fff',
  },
  headerContent: {
    display: 'flex',
    justifyContent: 'space-evenly',
  },
  headerButton: {
    textTransform: 'capitalize',
    color: '#70142C',
    border: '1px solid #70142c',
    [theme.breakpoints.down('md')]: {
      marginTop: 20,
    },
    '&:hover': {
      border: '1px solid #70142c',
      backgroundColor: 'rgba(0, 0, 0, 0.08)',
    },
  },
  logo: {
    width: 80,
  },
  order: {
    marginRight: 20,
    backgroundColor: '#70142c',
    color: '#fff',
    padding: '9px 13px',
    borderRadius: theme.shape.borderRadius,
    border: 'none',
    fontSize: 17,
    '&:hover': {
      backgroundColor: '#70142bb3',
      border: 'none',
      color: '#fff',
    },
  },
  scrollUp: {
    position: 'fixed',
    bottom: 30,
    right: 80,
    backgroundColor: '#70142C',
    color: '#fff',
    borderRadius: theme.shape.borderRadius * 3,
    zIndex: 9999,
  },
  margin: {
    // margin: theme.spacing.unit,
    // marginRight: 30,
    // marginLeft: 100,
    // minWidth:200,
    background: 'white',
    border: '1px #C8C8C8 solid',
    borderRadius: '7px',
  },
  textField: {
    flexBasis: 200,
  },
  leftIcon: {
    marginRight: '34px',
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
  scrollTransition: {
    right: 20,
  },
  banner: {
    color: '#fff',
    width: '50%',
    bottom: '6px',
    padding: '17px 6px',
    position: 'fixed',
    textAlign: 'center',
    backgroundColor: '#70142b',
    margin: 'auto',
    display: 'block',
    textAlign: 'center',
    left: '25%',
    borderRadius: '5px',
  },
  bannerInfo: {
    fontWeight: 'bold',
    letterSpacing: 1,
    wordBreak: 'break-word',
  },
});

class Ordering extends Component {
  state = {
    query: '',
    freeFlag: this.props.freeItemFlag,
  };

  queryChange = (evt) => {
    this.setState({ query: evt.target.value });
  };
  render() {
    const { classes, info, promoCode, total, color } = this.props;
    // promo code for total price
    const promoCodeDiscountTotal = (total / 100) * promoCode;
    const promoCodeTotal = total - promoCodeDiscountTotal;

    let itemcount = 0;
    for (let idx in this.props.cart) {
      // console.log(this.props.cart[idx]);
      if (this.props.cart[idx].price != 0)
        itemcount += this.props.cart[idx].count;
    }
    return (
      <div id='whole-thing'>
        <Grid container spacing={0}>
          <Hidden smDown>
            <ScrollUpButton
              ShowAtPosition={600}
              EasingType='easeInOutQuad'
              AnimationDuration={1000}
              ContainerClassName='scroll-container'
              style={{ backgroundColor: this.props.color }}
              TransitionClassName={classes.scrollTransition}
            >
              <ScrollButton />
            </ScrollUpButton>
          </Hidden>
          {/* <Hidden xsDown>
            <Grid item sm={4}>
              <div id='cat-sideBar'>
                <div id='checkout-header' />
              </div>
            </Grid>
          </Hidden> */}

          {/* <li><a href="#section-3">section 1</a></li> */}

          <div className='tabs-container-test'>
            {/* <div className='desktop-header'> */}
            {/* <AppBar position='static' className={classes.header}> */}
            {/* <Toolbar className={classes.headerContent}> */}
            {/* <img src={info.logo} className={classes.logo} alt='logo' /> */}
            {/* <div> */}
            {/* <Scrollspy
                      // offset={1000}
                      items={['order']}
                      currentClassName='is-current'
                    > */}
            {/* <Scroll type='id' element='order'>
                        <a href='#order' style={{ textDecoration: 'none' }}>
                          <Button
                            className={classNames(
                              classes.headerButton,
                              classes.order
                            )}
                            color='primary'
                            variant='outlined'
                          >
                            {strings.order_now}{' '}
                            <RestaurantMenu style={{ marginLeft: 10 }} />
                          </Button>
                        </a>
                      </Scroll> */}

            {/* </Scrollspy> */}
            {/* </div> */}
            {/* </Toolbar> */}
            {/* </AppBar> */}
            {/* </div> */}

            {/* <img src={info.poster} className='desktop-cover' /> */}
            <div className='desktop-tabs-container' id='order'>
              <div className='desktop-tabs'>
                <ScrollNav
                  id='scrollnav'
                  // queryChange={this.props.queryChange}
                  // query={this.props.query}
                  // clear={this.props.clear}
                  categories={
                    this.props.categories
                      ? this.props.categories
                      : ['most popular items']
                  }
                  info={info}
                  color={this.props.color}
                  logo={this.props.logo}
                />
                {/* {console.log('info', info)} */}
                {/* <img src={info.logo} className={classes.logo} alt='logo' /> */}
              </div>
              <div className='vertical-divider' />
              {/* search bar */}
              <div
                className='desktop-searchbar'
                style={{ marginLeft: 15, marginRight: 30 }}
              >
                <SearchBar
                  queryChange={this.props.queryChange}
                  query={this.props.query}
                  clear={this.props.clear}
                />
              </div>
              {/* search bar */}
              {/* navbar buttons */}
              <Link
                to='/history'
                style={{
                  textDecoration: 'none',
                  marginRight: 10,
                }}
              >
                <Button
                  className={classes.headerButton}
                  style={{
                    color: this.props.color,
                    border: `1px solid ${this.props.color}`,
                  }}
                >
                  <Typography
                    style={{
                      color: this.props.color,
                      paddingRight: this.props.nonAcceptedOrders ? 19 : 0,
                    }}
                    display='block'
                  >
                    {strings.orders}
                  </Typography>
                  {this.props.nonAcceptedOrders && (
                    <StyledBadge
                      style={{
                        backgroundColor: `${this.props.color} !important`,
                      }}
                      badgeContent={this.props.nonAcceptedOrders}
                    />
                  )}
                </Button>
              </Link>

              <Link to='/about' style={{ textDecoration: 'none' }}>
                <Button
                  className={classes.headerButton}
                  style={{
                    color: this.props.color,
                    border: `1px solid ${this.props.color}`,
                  }}
                >
                  {strings.about_us}
                </Button>
              </Link>
              {/* navbar buttons */}
              {/* <div className='desktop-button-container'>
                <Button
                  className='deskotop-cart-button'
                  title='Reorder'
                  variant='text'
                  style={{ cursor: 'default' }}
                >
                  {' '}
                  <ShoppingCartIcon
                    className={classNames(classes.leftIcon, classes.iconSmall)}
                  />
                  {itemcount}
                </Button>
              </div> */}
            </div>
          </div>
          {/* <Grid item sm={8} style={{ width: '100%' }}> */}
          <div style={{ width: '100%' }} className='margin-container'>
            {/* <Hidden mdUp> */}
            <div className='fb-tabs-hidden'>
              <ScrollNav
                id='scrollnav'
                queryChange={this.props.queryChange}
                query={this.props.query}
                clear={this.props.clear}
                info={info}
                color={this.props.color}
                categories={
                  this.props.categories
                    ? this.props.categories
                    : ['most popular items']
                }
              />
            </div>
            {/* </Hidden> */}
            {/* <NavLink to="/history"><Button>History</Button></NavLink> */}
            <Grid container>
              <Grid item xs={3} />
              <Grid item xs={6}>
                <div className='search-container'>
                  {/* <SearchIcon style={{"display":"inline"}}/>
         <TextField placeholder="search for items" onChange={this.queryChange}  className={classNames(classes.margin, classes.textField)}
          variant='filled'
          fullWidth
          label="With outlined TextField"/> */}
                  {/* <InputBase className={classes.margin} defaultValue="Naked input" /> */}
                </div>
              </Grid>
              <Grid item xs={3} />
            </Grid>
            {/* the main content */}
            <Grid
              container
              spacing={16}
              className='hide-menu'
              // style={{ position: 'relative', top: '3%' }}
            >
              <Grid
                item
                md={7}
                sm={7}
                style={{ width: '100%' }}
                className='menu-content-container'
              >
                {this.props.hasLoaded ? (
                  <div id='menu-content'>
                    {this.props.isOpen ? (
                      <Categories
                        menu={this.props.menu}
                        query={this.props.query}
                        click={this.props.click}
                        promoCode={this.props.promoCode}
                        color={this.props.color}
                      />
                    ) : (
                      <React.Fragment>
                        <h1 style={{ textAlign: 'center' }}>
                          Dear Customer, Sorry we can't take orders now!
                        </h1>
                        <h1 style={{ textAlign: 'center' }}>
                          Our online delivery hours are from{' '}
                          {this.props.willOpenIn} to {this.props.willCloseIn}
                        </h1>
                        <h1 style={{ textAlign: 'center' }}>
                          {this.props.callCenterText
                            ? this.props.callCenterText
                            : null}
                        </h1>
                      </React.Fragment>
                    )}
                  </div>
                ) : null}
              </Grid>
              <Grid item md={4} sm={4}>
                {/* order checkout */}
                {this.props.cart.length > 0 && (
                  <Order
                    restaurant_name={this.props.restaurant_name}
                    messenger_user_id={this.props.messenger_user_id}
                    total={total}
                    cart={this.props.cart}
                    promoCode={this.props.promoCode}
                    color={this.props.color}
                  />
                )}

                {/* order checkout */}
              </Grid>
            </Grid>
            {/* scroll up button */}
            {/* <Hidden smDown>
            <div className={classes.scrollUp}>
              <IconButton style={{color : '#fff'}}>
                <ArrowUpwardIcon />
              </IconButton>
            </div>
            </Hidden> */}
            {/* <ScrollToTop showUnder={160}>
              <span>UP</span>
            </ScrollToTop> */}
            {/* scroll up button */}
            {/* the main content */}

            {/* <div id="footer">
          <div>
              <div className="row">
              <NavLink to="/editcart" style={{ textDecoration: 'none' ,color: 'inherit'}}><div className="col s2 m1 center-align" id="cart"><span className="flow-text cart-span"><i className="fa fa-shopping-bag fa-lg"></i></span>
               </div></NavLink>
                <div className="col s4 m2 center-align" id="order-total"><span className="flow-text order-total-span">Total:{Number(this.props.total).toFixed(1)}</span>
                </div>
                <div className="col s6 m7 center-align" id="checkout"><NavLink to="/checkout" className="waves-effect waves-teal btn-flat flow-text" ><span id="checkout-span">Checkout</span> <span id="checkout-icon-span"><MaterialIcon id="checkout-button-icon" icon="chevron_right" size={28} color='#FFF'/></span></NavLink>
                </div>
              </div>
            
            </div>
         {/* </div> */}
            {!this.props.isMenu && !itemcount == 0 ? (
              <div className='fixed-button-placeholder'>
                <div id='footer' style={{ backgroundColor: this.props.color }}>
                  {/* <Grid item xs = {2} sm = {1} >
        <NavLink to="/editcart" style={{ textDecoration: 'none' ,color: 'inherit'}}><div className="" id="cart"><span className="cart-span"><Badge badgeContent={itemcount} color="primary"><i className="fa fa-shopping-bag fa-lg"></i></Badge></span>
           </div></NavLink>
      <Divider
      {/* <Grid item xs = {2} sm = {5}>
      <div className="s4" id="order-total"><span className="order-total-span">{Number(this.props.total).toFixed(1)}</span></div>
      </Grid> */}
                  <Grid item xs={12} sm={7}>
                    {/* {itemcount==0? */}

                    <div className='s6' id='checkout'>
                      <NavLink to='/checkout' className='btn-flat'>
                        <span>{strings.checkout}</span>
                        {/* <span className="order-total-span" id="order-total">{Number(this.props.total).toFixed(1)+ " EGP"}</span> */}
                        <span
                          onClick={() => {
                            // console.log('go to checkout page');
                            ReactPixel.trackCustom(
                              `desktop - ${this.props.restaurant_name} - go to checkout page`,
                              {
                                userID: this.props.messenger_user_id,
                              }
                            );
                            ReactPixel.trackCustom(
                              'desktop - go to checkout page'
                            );
                          }}
                          id='checkout-span'
                          title='checkout-span'
                          style={{
                            textDecoration: promoCode ? 'line-through' : 'none',
                          }}
                        >
                          <span style={{ marginLeft: 10 }}>
                            {Number(total).toFixed(2) + strings.currency}
                          </span>
                        </span>
                        {promoCode && (
                          <span style={{ marginLeft: 10 }}>
                            {promoCodeTotal.toFixed(2)} {strings.currency}
                          </span>
                        )}
                        {/*<span id="checkout-icon-span"><MaterialIcon id="checkout-button-icon" icon="chevron_right" size={30} color='#FFF'/></span>*/}
                      </NavLink>
                    </div>
                  </Grid>
                </div>
              </div>
            ) : null}
            {
              /* banner */
              //  console.log(
              //   'this.props.isFirstOrder' +
              //     this.props.isFirstOrder +
              //     this.props.freeItemFlag
              // )
            }
            {this.props.cart.length === 0 &&
              this.props.isFirstOrder &&
              this.props.freeItemFlag && (
                <div className={classNames(classes.banner, 'banner-container')}>
                  <span className={classes.bannerInfo}>
                    {this.props.freeItem.en_panner}
                  </span>
                </div>
              )}
            {/* banner */}
          </div>

          {/* </Grid> */}
        </Grid>
      </div>
    );
  }
}
Ordering.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Ordering);



// WEBPACK FOOTER //
// ./src/Ordering.js